import React, {Component} from 'react'
import {Actions} from 'jumpstate'
import {Row, Tabs, Tab, Button} from 'react-bootstrap'
import NotificationComponent from './NotificationComponent'
import HorseLoading from '../../Common/HorseLoading/HorseLoading'

import './Layout/Notification.css'

class NotificationScreen extends Component {
  constructor (props) {
    super(props)
    this.state = {
      page: 1,
      list: [],
      hasNextPage: false,
      isLoading: true
    }
    this.loadNextPage = this.loadNextPage.bind(this)
    this.getList = this.getList.bind(this)
  }

  getList (atPage = 1) {
    Actions.notificationList(atPage).then((res) => {
      this.setState({isLoading: false})
      if (res.data.length === 0) {
        this.setState({hasNextPage: false})
        return undefined
      }
      this.setState({
        list: this.state.list.concat(res.data),
        hasNextPage: (res.data.length >= 10),
        page: atPage
      })
    })
  }

  componentWillMount () {
    this.setState({isLoading: true})
    this.getList()
  }

  loadNextPage () {
    this.getList(this.state.page + 1)
  }

  render () {
    const { isLoading, hasNextPage, list } = this.state
    return (
      <Row className="Box">
        <Tabs defaultActiveKey={1} id="uncontrolled-tab-example">
          <Tab eventKey={1} title="اعلانات">
            <div id="notification">
              {isLoading ? <HorseLoading /> : list.map((item, index) => <NotificationComponent key={index} item={item} loader={(id) => this.notificationLoader} />)}
              {hasNextPage && <Button bsStyle="info" onClick={this.loadNextPage} block>نمایش بیشتر...</Button>}
            </div>
          </Tab>
        </Tabs>
      </Row>
    )
  }
}

export default NotificationScreen



// WEBPACK FOOTER //
// ./src/components/User/Notification/NotificationScreen.js